import { render, staticRenderFns } from "./LaboratorioView.vue?vue&type=template&id=e92d1e3c"
import script from "./LaboratorioView.vue?vue&type=script&lang=js"
export * from "./LaboratorioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports